
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.011 6.215c-1.711-.009-3.86.918-5.499 2.557a8.852 8.852 0 00-1.601 2.174c1.479-1.119 3.057-1.47 4.903-.434a21.67 21.67 0 012.197-4.297zm9.785 9.773a23.565 23.565 0 01-4.297 2.21c1.036 1.848.686 3.424-.434 4.902a8.804 8.804 0 002.175-1.602c1.644-1.642 2.572-3.796 2.556-5.51zM23.948.042A17.883 17.883 0 0022.735 0C14.133 0 9.237 6.558 7.455 11.833l4.728 4.729C17.611 14.616 24 9.901 24 1.39c0-.439-.017-.888-.052-1.348zm-9.888 9.91a.999.999 0 111.414-1.414.999.999 0 11-1.414 1.414zm2.828-2.828a2 2 0 112.828-2.828 2 2 0 01-2.828 2.828zM1.969 19.578l-.906-.906 5.208-5.188.906.906-5.208 5.188zm4.979 1.857l-.906-.906 3.636-3.664.906.906-3.636 3.664zM.906 24L0 23.094l6.448-6.438.906.906L.906 24z"}})])
          )
        }
      }
    